import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import { StyledDriveItemSelectionIcon as SelectionTogglerButton } from './styles';
import { StyleColor } from '../../../utils/styles-constants';
import { SelectionType, toggleSelection } from '../../../containers/Selection/actions';
import { ResolutionDisplayType } from '../../../utils/driveItem';
import Utils from '../../../utils';
import UserAgentUtils from '../../../utils/userAgent';
import Tooltip from '../../Tooltip';
import { hexToRgba } from '../../../utils/style';

const notInSelectionIcon = 'iconset_uprez_selection';
const inSelectionIcon = 'iconset_uprez_selection-bold';

interface SelectionTogglerProps {
	itemId: number;
	dispatch: Dispatch<StoreState>;
	displayMode: ResolutionDisplayType;
	isRowView?: boolean;
	needBottomPadding?: boolean;
	color: string;
	isInSelection: boolean;
	selectionType?: SelectionType;
}

class SelectionToggler extends React.Component <SelectionTogglerProps, {}> {
	constructor(props: SelectionTogglerProps) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	render() {
		const { displayMode, color, needBottomPadding, isInSelection, isRowView } = this.props;
		const svgIcon = Utils.getSvgIcon(!isInSelection && displayMode === ResolutionDisplayType.Detail ? notInSelectionIcon : inSelectionIcon);
		const isCard = displayMode === ResolutionDisplayType.Card;
		const isDetail = displayMode === ResolutionDisplayType.Detail;
		const isCoverFlow = displayMode === ResolutionDisplayType.Coverflow;
		const tooltipId = Utils.generateId();
		const tooltipText = isInSelection ? 'messages.remove_from_selection' : 'messages.add_to_selection';

		return (
			<SelectionTogglerButton
				onClick={this.handleClick}
				isCard={isCard}
				isInSelection={isInSelection}
				needBottomPadding={needBottomPadding}
				fillColor={color}
				strokeColor={!isInSelection ? hexToRgba(StyleColor.Grey400, 100) : ''}
				data-tip={isDetail}
				data-for={tooltipId}
				isRowView={isRowView}
				isCoverFlow={isCoverFlow}
			>
				{svgIcon}
				{(UserAgentUtils.isDesktop() && isDetail) &&
					<Tooltip id={tooltipId} text={tooltipText} />
				}
			</SelectionTogglerButton>
		);
	}

	handleClick(e: React.MouseEvent<HTMLDivElement>): void {
		const { itemId, selectionType, dispatch } = this.props;
		e.stopPropagation();
		dispatch(toggleSelection(itemId, selectionType));
	}
}

export {
	SelectionTogglerProps,
	SelectionToggler,
};

export default SelectionToggler;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Selection/Toggler/index.tsx